module.exports = __webpack_public_path__ + "img/H1.0514270c.png";